if (!customElements.get('shipping-notice')) {
  customElements.define(
    'shipping-notice',
    // eslint-disable-next-line no-undef
    class ShippingNotice extends window.BAO.CustomElement() {
      connectedCallback () {
        this.watchPurpleDot()
        this.watchOrderDeadline()
        this.setupListeners()
        this.checkView()
      }

      setupListeners () {
        window.BAO.eventBus.addEventListener(
          window.BAO.EVENTS.PRODUCT.VARIANT_CHANGED,
          this.checkView.bind(this),
        )
      }

      checkView (event = null) {
        if (event) {
          this.els.currentVariant.element.setAttribute(
            'data-current-variant-available',
            event.detail?.variant?.available,
          )
        }

        setTimeout(() => {
          const orderDeadlineViewEl = this.els.orderDeadlineView?.element
          const preorderViewEl = this.els.preorderView?.element
          const restockViewEl = this.els.restockView?.element

          switch (this.view) {
            case 'instock':
              orderDeadlineViewEl.setAttribute('aria-hidden', 'false')
              preorderViewEl.setAttribute('aria-hidden', 'true')
              restockViewEl?.setAttribute('aria-hidden', 'true')

              this.hideOrderNoteIfCustomerIsOutsideOfUK()

              this.setAttribute('aria-hidden', 'false')

              break
            case 'preorder':
              orderDeadlineViewEl.setAttribute('aria-hidden', 'true')
              preorderViewEl.setAttribute('aria-hidden', 'false')
              restockViewEl?.setAttribute('aria-hidden', 'true')
              break
            case 'restock':
              orderDeadlineViewEl.setAttribute('aria-hidden', 'true')
              preorderViewEl.setAttribute('aria-hidden', 'true')
              restockViewEl.setAttribute('aria-hidden', 'false')
              this.setAttribute('aria-hidden', 'false')
              break
            default:
          }
        }, 100)
      }

      watchPurpleDot () {
        const targetElement = this.externalEls.form.element

        const mutationCallback = (mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && node.id === 'pd-branding') {
                  this.checkView()
                  this.setAttribute('aria-hidden', 'false')
                  observer.disconnect()
                }
              })
            }
          }
        }

        const observer = new MutationObserver(mutationCallback)

        const observerConfig = {
          childList: true,
          subtree: true,
        }

        observer.observe(targetElement, observerConfig)
      }

      watchOrderDeadline () {
        const targetElement = this.querySelector('.shopify-app-block')

        const mutationCallback = (mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              if (
                window.theme.strings.products.product
                  .free_delivery_order_deadline_message &&
                window.Shopify.shop === 'oh-polly-uk.myshopify.com'
              ) {
                this.checkIfWeNeedToUpdateTheOrderDeadlineMessage()
              }

              this.checkView()
            }
          }
        }

        const observer = new MutationObserver(mutationCallback)

        const observerConfig = {
          childList: true,
          subtree: true,
        }

        observer.observe(targetElement, observerConfig)
      }

      checkIfWeNeedToUpdateTheOrderDeadlineMessage () {
        const eligibleForFreeDelivery = this.dataset.freeNextDayDelivery

        if (eligibleForFreeDelivery) {
          this.querySelector('.prd-OrderDeadlineApp').innerHTML =
            window.theme.strings.products.product.free_delivery_order_deadline_message
          this.els.deliveryNoteIcon.element.style.display = 'block'
        }
      }

      hideOrderNoteIfCustomerIsOutsideOfUK () {
        if (window.Shopify.currency.active === 'GBP') {
          if (
            sessionStorage.getItem('BAO-customer-visiting-country') &&
            sessionStorage.getItem('BAO-customer-visiting-country') !== 'GB'
          ) {
            this.setAttribute('aria-hidden', 'true')
          } else {
            this.setAttribute('aria-hidden', 'false')
          }
        }
      }

      get view () {
        if (
          this.externalEls.form.element.querySelector('purple-dot-learn-more')
        ) {
          return 'preorder'
        }
        if (
          this.els.currentVariant.element.dataset.currentVariantAvailable ===
          'false'
        ) {
          return 'restock'
        }
        if (
          this.els.currentVariant.element.dataset.currentVariantAvailable ===
          'true'
        ) {
          return 'instock'
        }
      }
    },
  )
}
